var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grid", style: _vm.gridVars }, [
    _c("div", { staticClass: "myRow myRow--top" }, [
      _vm.height > 1200
        ? _c(
            "div",
            {
              staticStyle: {
                width: "var(--layout-width)",
                overflow: "hidden",
                height: "1100px",
              },
            },
            [_c("SliderImages", { attrs: { tablet: true } })],
            1
          )
        : _c(
            "div",
            {
              staticStyle: {
                width: "var(--layout-width)",
                overflow: "hidden",
                height: "350px",
              },
            },
            [_c("SliderImages", { attrs: { tablet: true, densed: true } })],
            1
          ),
    ]),
    _c("div", { staticClass: "myRow myRow--mid" }, [
      _c("div", [
        _c("table", { staticClass: "table-collapse" }, [
          _c("tr", [
            _c("td", [_c("div", [_c("PunkteSammelBox")], 1)]),
            _vm._m(0),
            _c("td", [
              _c(
                "div",
                { on: { click: _vm.startOrder } },
                [_c("StarteBestellungButton")],
                1
              ),
            ]),
            _c("td", [_c("div", [_c("SprachAuswahl")], 1)]),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "myRow myRow--bottom" }, [
      _c(
        "div",
        [_c("Zahlungsarten", { attrs: { noborder: true, nopadding: true } })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("div", { staticStyle: { width: "40px" } })])
  },
]
render._withStripped = true

export { render, staticRenderFns }